module.exports = __webpack_public_path__ + "img/Sport-vlaanderen.f6c508c8.png";